export function removeParam(search: string, queryParam: string) {
  const urlParams = new URLSearchParams(search);
  if (urlParams.has(queryParam)) {
    urlParams.delete(queryParam);
  }
  return urlParams.toString();
}
